import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderSlot as _renderSlot, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e6f4163"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 mr-2" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Logo ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Notifi", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"font-size":"large","color":"red"} }, [
  /*#__PURE__*/_createTextVNode(" ALPHA Version"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    style: {"font-size":"small","font-color":"red"},
    target: "_blank",
    href: "mailto:info@cryptonotifi.xyz"
  }, "info@cryptonotifi.xyz")
], -1))

import { computed, inject, ref } from "vue";
import { useAppStore } from "@/store/pinia_app";
import VaIconMenuCollapsed from "@/components/icons/VaIconMenuCollapsed.vue";
import { useColors } from "vuestic-ui";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const appStore = useAppStore();
const { getColors } = useColors();
const colors = computed(() => getColors());
const minimized = computed({
  get: () => appStore.isSidebarMinimized,
  set: (value) => (appStore.isSidebarMinimized = value),
});

const moralis: any = inject("Moralis");
let li = false;
if (!moralis) li = false;
else {
  if (moralis.User.current()) li = true;
  else li = false;
}
const loggedIn = ref(li);

return (_ctx: any,_cache: any) => {
  const _component_va_image = _resolveComponent("va-image")!
  const _component_va_navbar_item = _resolveComponent("va-navbar-item")!
  const _component_va_navbar = _resolveComponent("va-navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_va_navbar, {
      color: "primary",
      shape: "",
      class: "mb-1"
    }, _createSlots({
      left: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(VaIconMenuCollapsed, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (minimized.value = !_unref(minimized))),
            class: _normalizeClass([{ 'x-flip': _unref(minimized) }, "va-navbar__item"]),
            color: _unref(colors).dark
          }, null, 8, ["class", "color"])
        ]),
        _createVNode(_component_va_navbar_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_va_image, {
              class: "logo",
              alt: "logo",
              src: "/logo.png"
            }, {
              error: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_va_navbar_item, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      center: _withCtx(() => [
        _hoisted_4
      ]),
      _: 2
    }, [
      (loggedIn.value)
        ? {
            name: "right",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "right")
            ])
          }
        : undefined
    ]), 1024)
  ]))
}
}

})